module.exports = __webpack_public_path__ + "img/切片-47.621a5757.jpg";